import { createContext, useContext, useEffect, useRef, useState } from 'react';


interface ITitle {id: string; title: string}
// Define the shape of the object
interface TitleContextObject {
  title: string
  titles: ITitle[];
  setTitles: (titles: ITitle[] | ((oldTitles: ITitle[]) => ITitle[])) => void;
}

// Create the context
const AppBarTitleContext = createContext<TitleContextObject | undefined>(undefined);

// Custom hook to access the context
// eslint-disable-next-line react-refresh/only-export-components
export const useAppBarTitle = () => {
  const context = useContext(AppBarTitleContext);
  if (!context) {
    throw new Error('useAppBarTitle must be used within a AppBarTitleContextProvider');
  }
  return context;
};

export const AppBarTitle = ({
  title,
  append = false
}: {
  title: string;
  append? : boolean;
}) => {
  const { setTitles } = useAppBarTitle();
  const id = useRef(Math.random().toString(36).substring(7));

  useEffect(() => {
    setTitles(oldTitles => {
      const newTitle = {
        id: id.current,
        title
      };
      const newTitles: ITitle[] = append ? [...oldTitles, newTitle] : [newTitle];
      return newTitles;
    });
    return () => {
      setTitles(oldTitles => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const newTitles = oldTitles.filter(oldTitle => oldTitle.id !== id.current);
        return newTitles;
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}

// Provider component to wrap your app
export const AppBarTitleContextProvider = ({ children }) => {
  const [titles, setTitles] = useState<ITitle[]>([]);

  return (
    <AppBarTitleContext.Provider
      value={{
        titles,
        setTitles,
        title: titles.map(title => title.title).join(" - ")
      }}
    >{children}</AppBarTitleContext.Provider>
  );
};


